import { render, staticRenderFns } from "./RolesList.vue?vue&type=template&id=dcaf51d0"
import script from "./RolesList.vue?vue&type=script&lang=js"
export * from "./RolesList.vue?vue&type=script&lang=js"
import style0 from "./RolesList.vue?vue&type=style&index=0&id=dcaf51d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports